import React, { useState } from "react";
import backendConfig from "../../../../config/backend";

export default React.memo(function PlayerImage({ player, className, id, alt, onClick, }) {
    const [dynamicClassName, setDynamicClassName] = useState(className);

    const handleError = (currentTarget) => {
        if (currentTarget.src.includes("?fallback=true")) {
            // If fallback has already been applied, do nothing
            return;
        }

        const originalSrc = currentTarget.src;

        // Only attempt to switch to SVG for images in /dynamic/team/ directory
        if (!originalSrc.endsWith(".svg") && originalSrc.endsWith(".png")) {
            // Switch to SVG and update class name
            currentTarget.src = originalSrc.replace(".png", ".svg");
            setDynamicClassName(`${className} svg-logo`); // Add extra class for SVG
        } else {
            // Apply existing fallback logic only after trying with .svg
            currentTarget.onerror = null; // prevents looping

            currentTarget.src = `/images/players/x4qyxhfr2vi007sazoqe5vit.png`;
            className = `${className}`;

            // Add a query parameter to mark that fallback has been applied
            currentTarget.src += "?fallback=true";

            // Reset class name to original if SVG fails
            setDynamicClassName(className);
        }
    };
    if (!player) return null;
    const {playerId} = player;
    const src = `/images/players/${playerId}.png`;
    return (
        <img
            src={src}
            id={id}
            className={dynamicClassName}
            alt={alt}
            onError={({ currentTarget }) => handleError(currentTarget)}
            onClick={onClick}
        />
    );
});
